import type { DuplexSignals } from '../state/duplexSignals.js';

export function DuplexStatus({ signals }: { signals: DuplexSignals }) {
  return <div className="duplex-status" role="group" aria-label={signals.spoken}>
    <span className="duplex-live"><span aria-hidden="true" />Live</span>
    <div className="duplex-sides">
      <DuplexPill label="You" active={signals.peopleSpeaking} side="you" />
      <DuplexPill label="Jabberr" active={signals.jabberrSpeaking} side="jabberr" />
    </div>
  </div>;
}

function DuplexPill({ label, active, side }: { label: string; active: boolean; side: string }) {
  return <span className={`duplex-pill duplex-${side}`} data-active={active} aria-label={`${label}: ${active ? 'talking' : 'quiet'}`}>
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      {side === 'you' ? <><rect x="9" y="2" width="6" height="12" rx="3" /><path d="M5 10v2a7 7 0 0 0 14 0v-2M12 19v3" /></> : <path d="M3 9v6M7 5v14M12 2v20M17 5v14M21 9v6" />}
    </svg>
    {label}
    <span className="duplex-bars" aria-hidden="true">{[0, 1, 2, 3, 4].map(i => <span key={i} style={{ animationDelay: `${i * -0.12}s` }} />)}</span>
  </span>;
}
